import { StatsStandard } from "../../../../modules/stats/components/StatsStandard/StatsStandard";
import type { IStatsBlockProps } from "./StatsBlock.props";

export const StatsBlock = (props: IStatsBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  return <StatsStandard {...props} />;
};

StatsBlock.displayName = "Block::StatsBlock";
